import { render, staticRenderFns } from "./user-timestamp-dashboard.vue?vue&type=template&id=795abe4b&scoped=true&"
import script from "./user-timestamp-dashboard.vue?vue&type=script&lang=js&"
export * from "./user-timestamp-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./user-timestamp-dashboard.vue?vue&type=style&index=0&id=795abe4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795abe4b",
  null
  
)

export default component.exports